const home = {
    'home.video.title': '세상을 치유해.',
    'home.video.btn': '작동 방식',
    'home.pro.learnMore': '자세한 내용',
    'home.join.title': '우리와 함께하고 함께 나아가세요',
    'home.join.btn': '동업자가 되다',
    'home.pro.title1': 'Snailcle S1시연.',
    'home.pro.con1': '똑똑해 보이고, 영적이고, 미니멀한 디자인, 딱딱한 선이 없고, 당신의 영혼을 부드럽게 합니다.',
    'home.pro.btn': '더 발견',
    'home.pro.title2': '자체 구동형 AI 리컴번트 바이크 R1',
    'home.pro.con2': '당신에게 더 잘 어울리는 또 다른 지방 감소 및 피트니스 제품이 발견되기를 기다리고 있습니다.귀엽고 컴팩트한 외관으로 도시적인 홈 스타일에 귀엽고 정교합니다.',
    'home.pro.title3': 'AI 자발적 전기 지능 카누 M1',
    'home.pro.con3': '스네일클의 힐링 기술 제품은 새로운 피트니스 옵션입니다. 원클릭 스토리지는 단순성, 패션성, 안전성을 다시 가져옵니다.',
    'home.app.title': '간편하고 편리합니다.',
    'home.app.con': 'Snailcle 앱은 열심히 일하는 것에서 추측을 가져갑니다.안내된 수백 개의 운동 및 프로그램을 살펴보고, 개인별 측정 기준을 검토하고, 이동 중인 운동을 살펴보고, 다음 주의 수업 일정을 잡으세요.',
    'home.app.btn': '탐험 앱',
    'home.brand.title': '국제 브랜드, 세계 표준.',
    'home.brand.con': '일본, 한국, 대만, 홍콩, 동남아시아에 출시.유럽, 미국, 중동 시장 같은 시간.',
    'home.price.num': 'KRW 1171477',
    'home.news.title': '최근 뉴스다.',
    'home.news.btn': '더 읽고',
    'homeR1.price.num': 'KRW 1041168',
    'homeM1.price.num': 'KRW 910859',
}
const product = {
    'product.play.btn': '지금 연극',
    'product.title': 'AI 스마트 자전거 S1',
    'product.banner.title1': 'Snailcle S1 세상을 치유해.',
    'product.banner.con1': 'Snailcle S1은 스네일처럼 귀여운 외관을 가지고 있으며 따뜻함, 힐링, 기술이 가득한 피트니스 제품입니다.',
    'product.banner.title2': '재미있는 라이딩이 가능한 Snailcle 앱.',
    'product.banner.con2': 'Snailcle 앱을 지원하시면 라이딩을 재미로 가득 채워주는 랜덤 사이클링, 프로그램, 셀렉트 루트, 대회, 일반석 등을 찾으실 수 있습니다.',
    'product.Exclusive.Features': '독보적인 기능, 당신 주변에서 일하세요! ',
    'product.banner.title3': '두 가지 스타일, 항상 취향에 맞는 것이 있습니다.',
    'product.banner.con3': '규격이다.',
    'product.gifBanner.title1': '스마트',
    'product.gifBanner.con1': '달라 보이고, 눈에 띈다.미니멀한 디자인, 딱딱한 선이 없습니다.영혼을 부드럽게 해!',
    'product.gifBanner.title2': '자동 높이 조정',
    'product.gifBanner.con2': '전원에 연결되면 Snailcle bike는 핸들바와 시트 높이를 가장 낮은 위치로 회복하여 쉽게 스텝오버할 수 있습니다.',
    'product.gifBanner.title3': '약간 조정',
    'product.gifBanner.con3': '당신이 약간의 조정을 원하더라도, 자리를 떠날 필요가 없고, 그냥 핸들 바의 버튼을 누르십시오.',
    'product.gifBanner.title4': 'AI 자세 감지',
    'product.gifBanner.con4': '특허 중력 센서 식별 및 AI 자세 계산식의 지원으로 Snailcle bike는 당신의 신체 움직임 자세를 감지하고, 당신에게 가장 적합한 저항 값을 맞춰줄 것입니다.',
    'product.gifBanner.title5': 'AI 자세 분석',
    'product.gifBanner.con5': '앞으로 이동하면 저항군이 자동으로 잉크라이 (incraese) 합니다.당신이 똑바로 앉으면, 저항이 자동적으로 줄어들 것입니다.',
    'product.imgBanner.title1': '사이클 링 시뮬레이션',
    'product.imgBanner.con1': '보다 도전적인 슬로프 시뮬레이션과 함께 현실을 시뮬레이션하는 루프를 제공하며 게임을 하는 것처럼 느껴집니다.',
    'product.imgBanner.title2': '간단 한 타',
    'product.imgBanner.con2': '목표도 없고, 통제도 없고, 물론 한계도 없다.무임승차입니다.당사는 귀하의 데이터를 기록할 책임만 있습니다.',
    'product.imgBanner.title3': '탈 프로그램',
    'product.imgBanner.con3': '고객의 실질적인 요구에 부응하기 위해 저항을 제어하고 단계 빈도 데이터를 감지하여 원하는 훈련 효과를 얻을 수 있는 다기능 사이클링 프로그램을 마련했습니다.',
    'product.imgBanner.title4': '수업과 실제 경치',
    'product.imgBanner.con4': '코스에서는 제한이 없고 전문 코치만이 훈련법을 지도하고 동행한다;실제 현실에서는 미관과 실제 경사를 느끼는 것과는 별개로 완전히 몸을 풀어 더 짧은 시간 안에 루트를 완주하려고 할 수 있다.',
    'product.imgBanner.title5': '사이클링 데이터 개요',
    'product.imgBanner.con5': "각 라이드의 데이터 외에도 불이 켜진 사각형을 통해 최근 얼마나 자주 운동을 했는지보다 직관적으로 알 수 있습니다.",
    'product.proList.title1': '넓고 부드러운 안장',
    'product.proList.con1': '보장된 편안함을 위해 넓고 부드러운 안장을 갖추고, 페달을 얼마나 오래 그리고 얼마나 빨리 밟든, 당신의 운동은 가능한 한 쾌적하게 느껴질 것입니다.',
    'product.proList.title2': 'EMS 마그네틱 시스템',
    'product.proList.con2': '빠른 반응으로 특수 설계된 EMS 마그네틱 시스템으로 딸림 없이 부드러운 페달링을 지원합니다.',
    'product.proList.title3': '춤추는 테일라이트',
    'product.proList.con3': '테일 라이트 컬러가 스크롤 휠 컬러와 매치되어 당신의 라이딩과 함께 춤을 춥니다.이 표시등은 또한 Bluetooth의 연결 또는 연결을 끊었음을 나타냅니다.',
    'product.proList2.title1': '다기능 손잡이',
    'product.proList2.con1': '핸들의 위치는 휴식 모드, 운동 모드, 경쟁 모드 등 3가지가 있다',
    'product.proList2.title2': '솔리드 바디, 당신을 만날 수 있는 최대 범위.',
    'product.proList2.con2': '사용자 키 범위:150cm-190cm.맥스.사용자 무게:120kg.',
    'product.proList2.title3': '잠자는 모드',
    'product.proList2.con3': '기계가 15분 동안 아무런 작동 없이 있으면 자기 시스템이 에너지 절약 목적 (24V 이하)으로 작동을 멈춥니다.',
    'product.specificationList.title1': '어 셈 블리 크기:',
    'product.specificationList.title2': '사용자 무게:',
    'product.specificationList.title3': '저항 수준:',
    'product.specificationList.title4': '최대 출력:',
    'product.specificationList.title5': '전원 공급 장치:',
    'product.specificationList.title6': '핸들 조정 범위 & 방법:',
    'product.specificationList.title7': '좌석 조절 범위 & 방식:',
    'product.specificationList.con6': '190mm, 전력 조정',
    'product.specificationList.con7': '170mm, 전원/수동 조정',
    'product.customerReviews': '고객 의견',
    'productR1.title': 'AI 침대 자전거 R1',
    'productR1.banner.title1': 'Snailcle R1 세상을 치유해.',
    'productR1.banner.con1': '스네일클 R1은 따뜻함과 힐링, 기술이 모두 담긴 자가 생성 피트니스 제품으로 보다 폭넓은 사람들에게 적합합니다.',
    'productR2.Exclusive.Features': '독보적인 기능, 당신 주변에서 일하세요!',
    'productR1.imgBanner.title1': '손쉬운 시작',
    'productR1.imgBanner.con1': '파워 길이 조절, 380mm 큰 공간의 리클라이닝.쉽게 타고 내리기, 사용자 높이 범위:1.5m-2m.',
    'productR1.imgBanner.title2': '손쉬운 조정',
    'productR1.imgBanner.con2': '최대 5명의 가족 구성원이 개별적으로 설치할 수 있는 길이 메모리 시스템과 인간적인 디자인으로 매번 조정하는 수고를 덜어줍니다.',
    'productR1.imgBanner.title3': '자기 역량',
    'productR1.imgBanner.con3': '친환경적이고 환경 친화적인 자력 시스템을 채택하여 운동에 가치를 부여합니다.사용 중 발생하는 운동 에너지를 전기 에너지로 변환하여 기기에 지속적이고 충분한 전력을 공급할 수 있으며, 휴대폰이나 패드와 같은 외부 기기를 충전할 수도 있습니다.',
    'productR1.imgBanner.title4': '더 실감나는 라이딩 (Riding)',
    'productR1.imgBanner.con4': "R1 저항은 PMS 전자기 제어 시스템을 사용하여 초음소거, 저소음, 무실속, 안정적이고 안전하다.1-36 레벨의 몇 밀리초 동안 속도를 높이거나 줄여 운동량과 효율을 유지할 수 있습니다.이는 다양한 사람들의 운동 강도 요구를 충족시키기 위해 실제 야외 자전거 타기 경험을 제공합니다.",
    'productR1.imgBanner.title5': '과학적으로 효과적인 ',
    'productR1.imgBanner.con5': "R1은 핸드그립 심박수 기능 내장 외에도 손목밴드, 심박수밴드, 완장 등 심박수 방송 기능을 갖춘 심박수 기기를 연결할 수 있다. Snailcle 앱은 심박수 모니터링과 알림 기능도 갖추고 있다.",
    'productR1.proList.title1': '콘솔 디스플레이',
    'productR1.proList.con1': '보장된 편안함을 위해 넓고 부드러운 안장을 갖추고, 페달을 얼마나 오래 그리고 얼마나 빨리 밟든, 당신의 운동은 가능한 한 쾌적하게 느껴질 것입니다.',
    'productR1.proList.title2': '더블 손잡이 설계',
    'productR1.proList.con2': '후미등 색상은 롤러 색상과 일치하며 라이딩과 함께 춤을 춥니다.또한 이 표시등은 Bluetooth 연결 또는 분리를 나타냅니다.',
    'productR1.proList2.title1': '기술은 운동을 더 이상 도전적이지 않게 만듭니다',
    'productR1.proList2.con1': 'Snailcle 팀은 AI 지능형 저항 제어, 야외 시뮬레이션 라이딩, 시각 인식, 인터랙티브 PK 도전 미니 게임을 일체화한 앱을 독립적으로 개발하여 운동이 더 이상 지루하지 않게 했다.',
    'productR1.proList2.title2': '당신을 보면 긴장이 풀리고, 당신을 사용하면 살이 빠지고, 만병치약 테크 뷰티 제품',
    'productR1.proList2.con2': 'R1은 1세대 S1Al 헬스바이크의 미학적 디자인 스타일을 이어왔다. 귀엽고 작고 정교해 도시 가정에 적합하다. 테일램프와 TFT를 오가며 오색 다이내믹 호흡등이 화룡점정 역할을 한다.전동 신축 시트도 Snailcle 브랜드의 독특한 디자인 컨셉을 부각시켰다.',
    'productR1.proList2.title3': '자유자재로 신축하여 이동이 편리하다.',
    'productR1.proList2.con3': 'Snailcle 브랜드의 독특한 디자인 컨셉은 모든 사용자 작업을 쉽고 간단하게 만듭니다.',
    'productR1.banner.title3': 'TFT 컬러 화면이 표시됩니다.거리, 열량 RPM, 저항, 전력, 심박수 모니터링 등 프로그램 라이딩, 무료 라이딩, 원클릭 저장, 위치 기억이 있는 쉬운 조작.외부 심박수 장치 연결.무선 충전, USB 충전 포트를 모두 사용할 수 있습니다.',
    'productR1.specificationList.information': '제품 기본 파라메터',
    'productR1.specificationList.title1': '출력: ',
    'productR1.specificationList.con1': '300W',
    'productR1.specificationList.title2': '전력 공급 방식: ',
    'productR1.specificationList.con2': '자연 전류',
    'productR1.specificationList.title3': ' ',
    'productR1.specificationList.con3': '콘센트가 필요 없습니다',
    'productR1.specificationList.title4': '제어 시스템: ',
    'productR1.specificationList.con4': '전자기 조종',
    'productR1.specificationList.title5': '플라이휠 중량: ',
    'productR1.specificationList.con5': '5.5kg',
    'productR1.specificationList.title6': '저항 기어: ',
    'productR1.specificationList.con6': '1-36단 스마트 저항 조절',
    'productR1.specificationList.title7': '의자가 오르내리다.: ',
    'productR1.specificationList.con7': '에어 컨트롤',
    'productR1.specificationList.title8': '거리를 밟다: ',
    'productR1.specificationList.con8': '전기 제어 조절',
    'productR1.specificationList.title9': '전자시계가 나타내다: ',
    'productR1.specificationList.con9': '노브 LED 디스플레이',
    'productR1.specificationList.title10': '인자 보이기:',
    'productR1.specificationList.con10': '저항, 시간, 속도, 칼로리, 빈도, 거리, 심장박동수, 힘;',
    'productR1.specificationList.title11': '절차: ',
    'productR1.specificationList.con11': '12개의 훈련 프로그램이 있습니다',
    'productR1.specificationList.title12': ' ',
    'productR1.specificationList.con12': '3개의 카운트다운 모드',
    'productR1.specificationList.title13': ' ',
    'productR1.specificationList.con13': '5명 사용자가 위치기억설정선택을 사용자 정의;',
    'productR1.specificationList.title14': 'App 지원: ',
    'productR1.specificationList.con14': 'Snailcle App',
    'productR1.specificationList.title15': 'Usb 포트: ',
    'productR1.specificationList.con15': '가',
    'productR1.specificationList.title16': '심장 박동장치 연결: ',
    'productR1.specificationList.con16': '네, 맥박 센서로',
    'productR1.specificationList.title17': ' ',
    'productR1.specificationList.con17': '심박수 방송 기능이 있는 무선 웨어러블 기기를 지원합니다',
    'productR1.specificationList.title18': '설비 받침대: ',
    'productR1.specificationList.con18': '가',
    'productR1.specificationList.title19': '身키 사용범위: ',
    'productR1.specificationList.con19': '150cm-190cm',
    'productR1.specificationList.title20': '사용자 최대 하중:',
    'productR1.specificationList.con20': '120kg',
    'productR1.specificationList.title21': '組み전체 기계 조립 후 최소 크기:',
    'productR1.specificationList.con21': '1335*652*1218mm',
    'productR1.specificationList.title22': '전체 조립 후 최대 크기:',
    'productR1.specificationList.con22': '1615*652*1218mm',
    'productR1.specificationList.Package&LoadingQty': '포장규격& 컨테이너수량',
    'productR1.specificationList.title26': '순 량이:',
    'productR1.specificationList.con26': '42kg',
    'productR1.specificationList.title27': '총중량은:',
    'productR1.specificationList.con27': '49kg',
    'productR1.specificationList.title28': '상자 크기:',
    'productR1.specificationList.con28': '1300*355*625mm',
    'productR1.specificationList.title29': '20’/40’/40HQ:',
    'productR1.specificationList.con29': '88 / 189 / 216',
    'productM1.title': 'AI 카누 M1',
    'productM1.banner.title1': 'Snailcle M1 세상을 치유해.',
    'productM1.banner.con1': '스네일클 M1은 귀엽고 콤팩트한 외관과 간편한 보관이 가능한 귀엽고 세련된 어반 홈 피트니스 제품입니다.',
    'productM1.banner.title2': 'Snailcle 앱으로 조정하기',
    'productM1.banner.con2': 'Snailcle 앱의 지원으로 무제한 조정, 조정 심박수 훈련 및 다양한 조정 프로그램 코스 연습을 할 수 있으며 데이터를 사용하여 모든 노력과 이득을 기록할 수 있습니다.',
    'productM1.imgBanner2.title1': '무제한 보트',
    'productM1.imgBanner2.con1': '프리 로잉에는 목표나 제한이 없으며, 앱 패널은 각 패들의 실시간 데이터를 표시하고 적시에 피드백을 제공합니다.',
    'productM1.imgBanner2.title2': '조정 심박수 훈련 ',
    'productM1.imgBanner2.con2': '로잉 심박수 훈련은 심박수 목표 설정에 따라 훈련 강도를 조절하는 운동 방법입니다. 이런 식으로 집중해야 할 것은 심박수뿐입니다.',
    'productM1.imgBanner2.title3': '프로그램 조정',
    'productM1.imgBanner2.con3': '고객의 실제 요구 사항을 충족하기 위해 저항을 제어하고 로잉 빈도 데이터를 모니터링하여 이상적인 운동 효과를 얻을 수 있는 다양한 로잉 훈련 프로그램을 설정했습니다.',
    'productM1.imgBanner.title1': '가족을 위한 새로운 선택',
    'productM1.imgBanner.con1': '700MM의 슬라이드 레일 전원 이동 공간.1.5 미터에서 2 미터까지는 300pound의 강자도 편하게 노를 저을 수 있다.',
    'productM1.imgBanner.title2': '단순함, 패션, 안전 ',
    'productM1.imgBanner.con2': '원 버튼 스토리지로 기존 조정 기계가 너무 길고 보관이 어려운 문제를 창의적으로 해결하면서 0.5 제곱미터만 차지합니다.',
    'productM1.imgBanner.title3': '자연 전류',
    'productM1.imgBanner.con3': '친환경적이고 환경 친화적인 자력 시스템을 채택하여 운동에 가치를 부여합니다.사용 중 발생하는 운동 에너지를 전기 에너지로 변환하여 기기에 지속적이고 충분한 전력을 공급할 수 있으며, 휴대폰이나 패드와 같은 외부 기기를 충전할 수도 있습니다.',
    'productM1.imgBanner.title4': '더 조용히 노를 젓고',
    'productM1.imgBanner.con4': "M1의 저항은 PMS 제어 시스템을 사용하여 초정숙성, 낮은 레이턴시, 지연 없음, 안정적이고 안전한 성능을 제공합니다.16 레벨 저항 선택으로 움직임의 관성과 높은 효율성을 유지하여 노를 저는 현실적인 경험을 달성하고 다양한 그룹의 사람들에게 운동의 강도 요구 사항을 충족시킵니다.",
    'productM1.imgBanner.title5': '과학적으로 효과적인 ',
    'productM1.imgBanner.con5': "M1은 핸드 그립 심박수 기능이 내장되어 있을 뿐만 아니라, 손목밴드, 시계, 심박수 벨트, 암밴드 등을 포함한 심박수 방송 기능이 있는 모든 심박수 장치에 연결할 수도 있습니다.Snailcle 앱에는 심박수 모니터링 및 미리 알림 기능도 있습니다.",
    'productM1.proList2.title1': '창조성이 당신의 세계를 치유하고, 기술을 사용하여 획일성을 근절하며, 치료 기술의 아름다움을 살아나게 하라',
    'productM1.proList2.con1': 'M1은 1세대 S1 알 피트니스 자전거의 미적 디자인 스타일을 이어갑니다:어반 홈을 위해 사랑스럽고, 작고, 섬세하게 스타일링된 미등과 TFT 셔틀 5 색 다이내믹 호흡 라이트가 마무리 손길을 연주합니다;파워 개폐식 시트 알소는 Snailcle 브랜드의 독특한 디자인 철학을 강조합니다.',
    'productM1.proList2.title2': '수축 및 연장이 자유로워 이동이 편리합니다',
    'productM1.proList2.con2': 'Snailcle 브랜드의 독특한 디자인 컨셉은 모든 사용자 작업을 쉽고 간단하게 만듭니다.',
    'productM1.banner.title3': 'TFT 컬러 스크린 전시:시간, 거리, 칼로리, countSPM, 저항, 전원, 심박수 모니터링 등; 프로그램, 자유, 원 버튼 저장, 쉬운 조작 외부 심박수 장치 연결, 장착 된 위타 USB 충전 인터페이스.',
    'productM1.specificationList.title1': '출력: ',
    'productM1.specificationList.con1': '300W',
    'productM1.specificationList.title2': '전력 공급 방식: ',
    'productM1.specificationList.con2': '자연 전류',
    'productM1.specificationList.title3': '수납 방식:',
    'productM1.specificationList.con3': '전동 개축 수납',
    'productM1.specificationList.title4': '저항 방식:',
    'productM1.specificationList.con4': '마그네틱 저항',
    'productM1.specificationList.title5': '플라이휠 중량: ',
    'productM1.specificationList.con5': '2kg',
    'productM1.specificationList.title6': '저항 기어: ',
    'productM1.specificationList.con6': '1-16단 스마트 저항 조절',
    'productM1.specificationList.title7': '슬라이드 재료:',
    'productM1.specificationList.con7': '알루미늄 합금',
    'productM1.specificationList.title8': '전자시계가 나타내다: ',
    'productM1.specificationList.con8': '노브 LED 디스플레이',
    'productM1.specificationList.title9': '인자 보이기:',
    'productM1.specificationList.con9': '저항, 시간, 칼로리, 거리, 심장박동수, 횟수, 보상 횟수',
    'productM1.specificationList.title10': '절차: ',
    'productM1.specificationList.con10': '12개의 훈련 프로그램이 있습니다',
    'productM1.specificationList.title11': ' ',
    'productM1.specificationList.con11': '3개의 카운트다운 모드',
    'productM1.specificationList.title12': 'App 지원: ',
    'productM1.specificationList.con12': 'Snailcle App',
    'productM1.specificationList.title13': 'Usb 포트: ',
    'productM1.specificationList.con13': '가',
    'productM1.specificationList.title14': '심장 박동장치 연결: ',
    'productM1.specificationList.con14': '예, 시스템은 펄스를 표시하기 위해 블루투스 무선 마모 자동 연결로 지원할 수 있습니다',
    'productM1.specificationList.title15': '설비 받침대: ',
    'productM1.specificationList.con15': '가',
    'productM1.specificationList.title16': '身키 사용범위: ',
    'productM1.specificationList.con16': '150cm-190cm',
    'productM1.specificationList.title17': '사용자 최대 하중:',
    'productM1.specificationList.con17': '120kg',
    'productM1.specificationList.title18': '組み전체 기계 조립 후 최소 크기:',
    'productM1.specificationList.con18': '1188*572*847mm',
    'productM1.specificationList.title19': '전체 조립 후 최대 크기:',
    'productM1.specificationList.con19': '1784*572*847mm',
    'productM1.specificationList.Package&LoadingQty': '포장규격& 컨테이너수량',
    'productM1.specificationList.title20': '순 량이:',
    'productM1.specificationList.con20': '30kg',
    'productM1.specificationList.title21': '총중량은:',
    'productM1.specificationList.con21': '37kg',
    'productM1.specificationList.title22': '상자 크기:',
    'productM1.specificationList.con22': '1260*355*650mm',
    'productM1.specificationList.title23': '20’/40’/40HQ:',
    'productM1.specificationList.con23': '100 210 / 244',
}
const distributor = {
    'distributor.title': '판매 지원',
    'distributor.toBecome': '협력 상생',
    'distributor.con': '지역 브랜드 인증',
    'distributor.con1': '공동 브랜드 프로그램',
    'distributor.con2': '전세계 에이전트 제휴 기회 (공동 브랜드 구축)',
    'distributor.con3': '공동 제품 혁신',
    'distributor.con4': '기술 진보를 공유하다',
    'distributor.contact': '아래에 연락처를 남겨주시면 최대한 빨리 연락드리겠습니다.',
    'distributor.phone': '전화:',
    'distributor.email': '이 메일:',
    'distributor.workingHours': '근무 시간:',
    'distributor.workingHours.con': ' 9am - 6pm(GMT+8)',
    'distributor.join': '함께하세요, Snailcle은 고객님께 신뢰받는 글로벌 피트니스 브랜드가 되겠습니다.'
}
const afterSales = {
    'afterSales.title': '판매 후',
    'afterSales.Video':'어 셈 블리 비디오.',
    'afterSales.click.download':'다운로드하려면 클릭하십시오:',
    'afterSales.app.download':'다운로드 앱니다.',
    'afterSales.con1':'Apple & Google play store에서"Snailcle"을 직접 검색할 수 있습니다.',
    'afterSales.con2':'QR 코드 아래에서도 스캔하여 다운로드가 가능합니다.',
    'afterSales.Assembly':'어 셈 블리 가이드',
    'afterSales.Manual':"사용 설명서",
    'afterSales.FunctionGuide': '기능 지침'
}
const about = {
    'about.title': '우리에 대해',
    'about.Story': '브랜드는 이야기다.',
    'about.Story.con1': `스네일클 (Snailcle)은 피트니스 제품을 스펙터클하게 만드는 혁신적인 피트니스 기술 회사입니다.부피가 크고 칙칙하며 검은색인 기존의 헬스제품보다 제품의 독창성, 참신성, 지능성, 동질성, 내용성을 강조하여 젊은 가족들을 위한"your first fitness machine"을 만드는 것이 그 사명.SNAILCLE이 처음 선보인 AI 센싱 피트니스 자전거 S1은이 회사의 공동 설립자이자 파트너인 중국과학기술대학 출신의 쑨하오박사가 혁신적인 컨셉 구축, ID 디자인, 첨단 다차원 힘 인식 센서, AI 자세 분석 알고리즘과 형태 인식 알고리즘 등의 팀을 이끌고 개발했으며 2022년 9월 대량 생산에 들어갔다.같은 해 에스원은 미국 크라우드펀딩 플랫폼 킥스타터에서 독자적인 연구 개발과 독립 브랜드로 처음 론칭해 성공을 거뒀다.이후 홍콩, 대만, 한국, 일본, 미국, 독일, 이스라엘, 인도, 러시아 등 시장에서 판매되면서 국제 브랜드 전략의 첫걸음을 달성했다.`,
    'about.Story.con2': '스네일클 패밀리 시리즈 제품인 R1리컴번트 바이크 & m1로잉 머신, 그리고 향후 출시될 신제품들은 모두 파워 리프팅, 파워 확장, 파워 스토리지라는 일관된 디자인 스타일을 따를 것이며, 이는 모든 스네일클 패밀리 제품에 더욱 차별화된 제품 특징을 불어넣을 것이다.',
    'about.Profile': '소개',
    'about.technology': 'SNAILCLE (샤먼) 기술 CO.,LTD',
    'about.join': '스네일클은 여성의 건강 관리에 초점을 맞춘 세계적인 홈 피트니스 브랜드입니다.진심으로, 소매 업체, 유통 업체, 온 라인 채널, 쇼핑몰 및 슈퍼 마켓이 우리와 함께 하는 것을 환영합니다.',
    'about.phone': '뜨 거 운 선:',
    'about.email': '이 메일:',
    'about.address': '주소: ',
    'about.address.con': '7th Floor, No.36, Bannan Road, Haicang District,Xiamen, China '
}
const contact = {
    'contact.title': '우리에게 연락',
    'contact.con1': '우리의 제품과 솔루션에 관심이 있습니까?',
    'contact.con2': '우리 제품을 사고 싶으세요?',
    'contact.con3': '우리 브랜드 홍보대사가 되세요?',
    'contact.con4': '유통업자가 된다고?',
    'contact.now': '지금 바로 연락하십시오!',
    'contact.message': "우리는 너의 소식을 듣고 싶다.양식을 사용하여 메시지를 보내주시기 바랍니다."
}
const support= {
    'support.title': '지원',
    'support.con1': '당사의 전문가로부터 전문적인 도움을 받으려면 지원 양식을 사용하십시오.포미스를 작성하는 것은 우리 팀이 당신의 문제를 빠르고 효과적으로 해결하는 데 도움이 될 것입니다.감사 합니다!',
    'support.con2': 'Snailcle 자전거를 구입해 주셔서 감사합니다!',
    'support.send.email': '이메일을 보내 주시기 바랍니다:',
    'support.con3': "뭐든 물어봐!24~28시간 이내에 다시 연락드리겠습니다.",
    'support.chat': '저희에게 말했습니다.',
    'support.con4': '즉시 도움을 요청하는 문제 또는 질문이 있는 경우 아래를 클릭하여 고객 서비스 담당자와 실시간 채팅할 수 있습니다.',
    'support.message': '클릭 한 번으로 정보를 보내주세요',
    'support.con5': "가능하지 않은 경우 왼쪽으로 이메일을 보내주시면 24-28시간 이내에 보내드리겠습니다.",
}
const shippingPolicy = {
    'shippingPolicy.title': '발송 정책',
    'shippingPolicy.con1': 'Snailcle 자전거를 구입해 주셔서 감사합니다!',
    'shippingPolicy.con2': '당사의 목표는 제품이 귀하에게 빠르고 안전하게 배송될 수 있도록 최대의 운송 옵션을 제공하는 것입니다.판매지역 및 각 배송정책에 각별히 유의하시기 바랍니다.',
    'shippingPolicy.con3': '주문 배송 타임라인은 두 부분으로 분리됩니다:',
    'shippingPolicy.time': '처리 시간:',
    'shippingPolicy.time.con': '48 영업시간 후에요.',
    'shippingPolicy.method': '배송 방법:',
    'shippingPolicy.method.con': 'Fedex & UPS & DPD & TNT...',
    'shippingPolicy.ShippingTime': '발송 시간:',
    'shippingPolicy.ShippingTime.con': '영업일 기준 5-7일',
    'shippingPolicy.ShippingFee': '배송 료:',
    'shippingPolicy.ShippingFee.con': '70만 원 이상 무료배송 주문',
}
const formType = {
    'form.label.Name': '당신의 이름을',
    'form.label.Company': '당신의 회사명',
    'form.label.email': '메일',
    'form.label.Comment': '당신의 의견',
    'form.label.Phone': '전화기',
    'form.label.Country': '당신의 나라',
    'form.label.Model': '제품 모델',
    'form.label.from': '구매처',
    'form.label.Purchase': '구매 증명서',
    'form.label.Description': '설명',
    'form.btn.sub': '제출 연락처',
    'form.message.valid.email': '입력한 전자 메일이 잘못되었습니다!',
    'form.message.enter.email': '이메일을 입력해 주세요!',
    'form.message.phone': '전화 번호를 입력하십시오!',
    'form.message.comment': '의견을 입력해 주십시오',
    'form.message.enter.comment': '여기에 의견을 남겨주세요',
    'form.message.des': '여기에 설명을 남겨주세요',
    'form.message.des.input': '설명을 입력해 주십시오',
    'form.message.purchase.input': '구매 증빙을 입력하십시오!',
    'form.message.from': '구매처를 입력해주세요',
    'form.message.Model': '제품 모델을 입력해 주세요!',
}
const whereToBuy = {
    'wheretobuy.title1': '구매 채널',
    'wheretobuy.con': '공식 구매 채널을 방문하십시오.',
    'wheretobuy.title2': '추가 구매 채널',
    'wheretobuy.Btn': '구매',
}
const header = {
    'header.menus.home': '홈 페이지',
    'header.menus.product': '제품',
    'header.menus.news': '뉴스',
    'header.menus.support': '판매 지원',
    'header.menus.after': '판매 후',
    'header.menus.about': '우리에 대해',
    'header.menus.contact': '우리에게 연락',
    'header.menus.proS1': 'AI 스마트 자전거 S1',
    'header.menus.proR1': 'AI 침대 자전거 R1',
    'header.menus.proM1': 'AI 카누 M1'
}
const footer = {
    'footer.menus.about': '에 대해',
    'footer.menus.about.Contact': '연락처',
    'footer.menus.about.About': '우리에 대해',
    'footer.menus.about.Distributor': '유통업자가 되다',
    'footer.menus.support': '서비스',
    'footer.menus.support.Support': '지원',
    'footer.menus.support.Shipping': '발송 정책',
    'footer.menus.support.Return': '반품 & 환불 정책',
    'footer.menus.support.Refund': '환불 정책',
    'footer.menus.support.Intellectual': '지적 재산권',
    'footer.menus.support.Privacy': '개인 정보 보호 정책',
    'footer.menus.support.Terms': '서비스 약관',
    'footer.menus.INFO': '정보',
    'footer.menus.INFO.New': '뉴스',
    'footer.menus.INFO.App': 'App',
    'footer.menus.INFO.FAQ': 'FAQ',
    'footer.menus.INFO.Installation': '설치',
    'footer.SUBSCRIBE': '구독해 주십시오',
    'footer.enterAddress': '이메일 주소 입력',
    'footer.Submit': '제출',
    'footer.pages.news.title': 'Snailcle 뉴스',
    'footer.pages.news.publish': '발표',
    'footer.pages.Support.title': '판매 지원',
    'footer.bottom.con': '©2020 酷蜗牛（厦门）科技有限公司 版权所有 闽ICP备2024032604号-1'
}
const download = {
    'download.meta.title': 'Snailcle - 스마트 피트니스 앱',
    'download.title': 'Snailcle',
    'download.subtitle': '더 나은 피트니스 여정을 위한 스마트한 동반자.',
    'download.status.ios': 'App Store를 여는 중...',
    'download.status.android': 'Google Play를 여는 중...',
    'download.store.apple.small': 'Download on the',
    'download.store.apple.large': 'App Store',
    'download.store.google.small': 'GET IT ON',
    'download.store.google.large': 'Google Play',
    'download.store.action': '다운로드',
    'download.qr.ios': 'iOS QR 코드',
    'download.qr.android': 'Android QR 코드',
    'download.footer.company': '©{year} SNAILCLE (XIAMEN) TECHNOLOGY CO., LTD.'
}
export default {
    ...home,
    ...product,
    ...distributor,
    ...afterSales,
    ...about,
    ...contact,
    ...support,
    ...shippingPolicy,
    ...formType,
    ...whereToBuy,
    ...header,
    ...footer,
    ...download
}
